import React from "react";

const TabPanel = ({ children, selectedTab, index }) => (
    <div
        style={{ marginTop: '20px' }}
        role='tabpanel'
        hidden={selectedTab !== index}
    >
        {selectedTab === index && children}
    </div>
);

export default TabPanel;
